import { render, staticRenderFns } from "./templateMng.vue?vue&type=template&id=1bd583a9"
import script from "./templateMng.vue?vue&type=script&lang=js"
export * from "./templateMng.vue?vue&type=script&lang=js"
import style0 from "./templateMng.vue?vue&type=style&index=0&id=1bd583a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports